import React, { useState } from "react";
import { useLocation } from "react-router-dom";

const CompanyInformation = ({
  refCompanyName,
  refNacionality,
  refCuit,
  refAge,
  refPhone,
  refEmail,
  refStreet,
  refNumberStreet,
  refLocation,
  refProvince,
  refPostalCode,
  refApartment,
  refFloor,
  refCodeOfWorkActivity,
  refActivityBeingCarriedOut,
}) => {
  const data = useLocation();
  const [company, setCompany] = useState({
    companyName: data.state.data.companyName || "",
    nacionality: data.state.data.nacionality || "",
    cuit: data.state.data.cuit || "",
    age: data.state.data.age || "",
    ageUnit: "years",
    phone: data.state.data.phone || "",
    email: data.state.data.email || "",
    documentType: data.state.data.documentType || "",
    status: "Alta",
    street: data.state.data.street || "",
    numberStreet: data.state.data.numberStreet || "",
    location: data.state.data.location || "",
    province: data.state.data.province || "",
    postalCode: data.state.data.postalCode || "",
    apartment: data.state.data.apartment || "",
    floor: data.state.data.floor || "",
    codeOfWorkActivity: data.state.data.codeOfWorkActivity || "",
    ActivityBeingCarriedOut: data.state.data.ActivityBeingCarriedOut || "",
    typeCustomer: "Persona Jurídica",
  });

  return (
    <div className="section">
      <div className="tittleupdatebox">
        <p className="tittleupdate">Informacion de la Empresa</p>
      </div>
      <div className="displayinputupdatebox">
        <div className="inputboxupdate">
          <label className="tittleinputupdate_Lealtad">Razón social:</label>
          <input
            ref={refCompanyName}
            className="inputupdate"
            type="text"
            defaultValue={company.companyName}
            onChange={(e) =>
              setCompany({
                ...company,
                companyName: e.target.value,
              })
            }
          />
        </div>
        <div className="inputboxupdate">
          <label className="tittleinputupdate_Lealtad">
            Años de la empresa:
          </label>
          <input
            ref={refAge}
            className="inputupdate"
            type="text"
            defaultValue={company.age}
            onChange={(e) =>
              setCompany({
                ...company,
                age: e.target.value,
              })
            }
          />
        </div>
        <div className="inputboxupdate">
          <label className="tittleinputupdate_Lealtad">Cuit:</label>
          <input
            ref={refCuit}
            className="inputupdate"
            maxLength="11"
            type="text"
            defaultValue={company.cuit}
            onChange={(e) =>
              setCompany({
                ...company,
                cuit: e.target.value,
              })
            }
          />
        </div>
      </div>
      <div className="displayinputupdatebox">
        <div className="inputboxupdate">
          <label className="tittleinputupdate_Lealtad">Teléfono:</label>
          <input
            ref={refPhone}
            className="inputupdate"
            type="text"
            defaultValue={company.phone}
            onChange={(e) =>
              setCompany({
                ...company,
                phone: e.target.value,
              })
            }
          />
        </div>
        <div className="inputboxupdate">
          <label className="tittleinputupdate_Lealtad">
            Correo electrónico:
          </label>
          <input
            ref={refEmail}
            className="inputupdate"
            type="text"
            defaultValue={company.email}
            onChange={(e) =>
              setCompany({
                ...company,
                email: e.target.value,
              })
            }
          />
        </div>
      </div>
      <div className="displayinputupdatebox">
        <div className="inputboxupdate">
          <label className="tittleinputupdate_Lealtad">Calle:</label>
          <input
            ref={refStreet}
            className="inputupdate"
            type="text"
            defaultValue={company.street}
            onChange={(e) =>
              setCompany({
                ...company,
                street: e.target.value,
              })
            }
          />
        </div>
        <div className="inputboxupdate">
          <label className="tittleinputupdate_Lealtad">Numero:</label>
          <input
            ref={refNumberStreet}
            className="inputupdate"
            type="text"
            defaultValue={company.numberStreet}
            onChange={(e) =>
              setCompany({
                ...company,
                numberStreet: e.target.value,
              })
            }
          />
        </div>
        <div className="inputboxupdate">
          <label className="tittleinputupdate_Lealtad">Codigo postal:</label>
          <input
            ref={refPostalCode}
            className="inputupdate"
            type="text"
            defaultValue={company.postalCode}
            onChange={(e) =>
              setCompany({
                ...company,
                postalCode: e.target.value,
              })
            }
          />
        </div>
      </div>
      <div className="displayinputupdatebox">
        <div className="inputboxupdate">
          <label className="tittleinputupdate_Lealtad">Localidad:</label>
          <input
            ref={refLocation}
            className="inputupdate"
            type="text"
            defaultValue={company.location}
            onChange={(e) =>
              setCompany({
                ...company,
                location: e.target.value,
              })
            }
          />
        </div>
        <div className="inputboxupdate">
          <label className="tittleinputupdate_Lealtad">Provincia:</label>
          <input
            ref={refProvince}
            className="inputupdate"
            type="text"
            defaultValue={company.province}
            onChange={(e) =>
              setCompany({
                ...company,
                province: e.target.value,
              })
            }
          />
        </div>
        <div className="inputboxupdate">
          <label className="tittleinputupdate_Lealtad">
            Pais de residencia:
          </label>
          <input
            ref={refNacionality}
            className="inputupdate"
            type="text"
            defaultValue={company.nacionality}
            onChange={(e) =>
              setCompany({
                ...company,
                nacionality: e.target.value,
              })
            }
          />
        </div>
      </div>
      <div className="displayinputupdatebox">
        <div className="inputboxupdate">
          <label className="tittleinputupdate_Lealtad">Piso:</label>
          <input
            ref={refApartment}
            className="inputupdate"
            type="text"
            defaultValue={company.floor}
            onChange={(e) =>
              setCompany({
                ...company,
                floor: e.target.value,
              })
            }
          />
        </div>
        <div className="inputboxupdate">
          <label className="tittleinputupdate_Lealtad">Departamento:</label>
          <input
            ref={refFloor}
            className="inputupdate"
            type="text"
            defaultValue={company.apartment}
            onChange={(e) =>
              setCompany({
                ...company,
                apartment: e.target.value,
              })
            }
          />
        </div>
        <div className="inputboxupdate">
          <label className="tittleinputupdate_Lealtad">
            Codigo de actividad laboral:
          </label>
          <input
            ref={refCodeOfWorkActivity}
            className="inputupdate"
            type="text"
            defaultValue={company.codeOfWorkActivity}
            onChange={(e) =>
              setCompany({
                ...company,
                codeOfWorkActivity: e.target.value,
              })
            }
          />
        </div>
      </div>
      <div className="displayinputupdatebox">
        <div className="inputboxupdate">
          <label className="tittleinputupdate_Lealtad">
            Actividad de la empresa:
          </label>
          <textarea
            ref={refActivityBeingCarriedOut}
            className="inputupdate"
            defaultValue={company.ActivityBeingCarriedOut}
            onChange={(e) =>
              setCompany({
                ...company,
                ActivityBeingCarriedOut: e.target.value,
              })
            }
          />
        </div>
      </div>
    </div>
  );
};

export default CompanyInformation;
